import { type TranslationTree } from '@/i18n/types';

export const messages = {
  loadError: 'Não foi possível carregar a oferta',
  back: 'Ofertas',
  edit: 'Editar',
  submit: 'Enviar para análise',
  resubmit: 'Reenviar para análise',
  archive: 'Arquivar',
  submitLocked: 'O envio para análise fica liberado quando a conta for aprovada.',
  submitted: 'Oferta enviada para análise',
  archived: 'Oferta arquivada',
  archiveModal: {
    title: 'Arquivar a oferta?',
    message: 'A oferta sai da lista de ativas e não pode mais ser editada nem enviada.',
    messageWithCampaign:
      'A campanha desta oferta é encerrada e ela sai do app agora. Não dá para desfazer.',
    confirm: 'Arquivar',
    back: 'Voltar',
  },
} satisfies TranslationTree;
